import { __decorate } from "tslib";
import { Component, Mixins, Watch, Provide } from 'vue-property-decorator';
import TopNav from '@/views/shared/TopNav.vue';
import TopSubNav from '@/views/shared/TopNavSubMenu.vue';
import SessionExpiredDialog from '@/views/shared/SessionExpiredDialog.vue';
import TuckingInMdrDialog from '@/views/v2/apps/TuckingInMdrDialog.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import SideNav from '@/views/shared/SideNav.vue';
import TheAlert from '@/views/shared/TheAlert.vue';
import TheBreadcrumb from '@/views/shared/TheBreadcrumb.vue';
import PageTransition from '@/components/page_transition/Index.vue';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import { CG_BASE_URL } from '@/helpers/constants/app';
import Modal from '@/components/v3/Modal.vue';
import NotificationList from '@/components/v2/NotificationList.vue';
import LandingDrawer from '@/components/LandingDrawer.vue';
import TheLaunchDialog from '@/components/v2/diy/TheLaunchDialog';
import TheSuccessDialog from '@/components/v2/diy/TheSuccessDialog';
import TheDiyTerms from '@/components/v2/diy/TheDiyTerms.vue';
import ToDoSuccess from '@/components/v3/ToDoSuccess.vue';
import PendingOrderReminder from '@/components/v3/PendingOrderReminder.vue';
import MayaDeactivationReminder from '@/components/v3/MayaDeactivationReminder.vue';
import AccumulatedConvenienceFee from '@/components/v2/AccumulatedConvenienceFee';
import EnterprisePlanFee from '@/components/v2/EnterprisePlanFee';
import BillingDeactivationNoticeDialog from '@/components/v2/BillingDeactivationNoticeDialog';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import MerchantCategoryDescription from '@/components/v3/modals/MerchantCategoryDescription.vue';
import CreditTopUpMixin from '@/helpers/vue_mixins/v2/CreditTopUpMixin';
import { Getter } from 'vuex-class';
import { NAV_DRAWER } from '@/helpers/constants/app';
import MobileUserSettings from '@/components/v2/MobileUserSettings.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterPathMixin from '@/helpers/mixins/RouterPathMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { STORE_MANAGEMENT } from '@/helpers/constants/CustomBundleKeys';
import PendingOrderNoticeDialog from '@/components/v2/PendingOrderNoticeDialog';
import SupportDetailsDialog from '@/components/v2/SupportDetailsDialog.vue';
import GracePeriodLastDayNoticeDialog from '@/components/v2/GracePeriodLastDayNoticeDialog';
import CreditWidget from '@/components/v2/CreditWidget';
import AffiliateMixin from '@/helpers/mixins/AffiliateMixin';
import UnverifiedNotificationEmails from '@/plugins/graphql/queries/unverified-notification-emails.gql';
import UnverifiedSupportEmails from '@/plugins/graphql/queries/unverified-support-emails.gql';
import UnverifiedBusinessEmails from '@/plugins/graphql/queries/unverified-business-emails.gql';
import appHasPendingOrders from '@/plugins/graphql/queries/v2/app-has-pending-orders.gql';
import FetchCategoryAndDesc from '@/plugins/graphql/queries/v3/fetch-category-and-desc.gql';
import CustomerDetails from '@/plugins/graphql/queries/v2/customer-details.gql';
import ActionButton from '@/components/action_button/Index.vue';
import AppResendVerificationEmail from '@/plugins/graphql/mutations/v2/app-resend-verification-email.gql';
import UserResendVerificationEmail from '@/plugins/graphql/mutations/v2/user-resend-verification-email.gql';
import me from '@/plugins/graphql/queries/me.gql';
import ShopifyProgressBar from '@/views/v3/ShopifyProgressBar.vue';
import AppGlobalId from '@/plugins/graphql/queries/v3/app-global-id.gql';
import AdvanceOrdersToday from '@/plugins/graphql/queries/v2/advance-orders-today.gql';
import MayaReminderQuery from '@/plugins/graphql/queries/v3/maya-deactivation-reminder.gql';
import RunMayaDeactivationNotice from '@/plugins/graphql/queries/v3/run-maya-deactivation-notice.gql';
import UpdatePageImage from '@/plugins/graphql/queries/v3/update-page-image.gql';
import BusinessMessagingPromotion from '@/components/v3/BusinessMessagingPromotion.vue';
import fetchSubscriptionInvitation from '@/plugins/graphql/queries/v2/copilot_inbox_manager/subscription-invitation.gql';
import AppStatus from '@/plugins/graphql/queries/v3/app-status.gql';
import updateBusinessPromotionReminder from '@/plugins/graphql/mutations/v2/update-business-promotion-reminder.gql';
import WhiteLabelRedirectMixin from './helpers/mixins/WhiteLabelRedirectMixin';
import ZendeskSupportMixin from './helpers/mixins/ZendeskSupportMixin';
import IdleListenerMixin from './helpers/mixins/IdleListenerMixin';
import AesMixin from './helpers/vue_mixins/v2/AesMixin';
import { UserType } from './helpers/entities/enums/UserType';
let App = class App extends Mixins(ViewportSizeMixin, RouterPathMixin, RouterParamsAppMixin, Mixins(CreditTopUpMixin, AlertMixin), Mixins(WhiteLabelRedirectMixin, ZendeskSupportMixin, IdleListenerMixin, AffiliateMixin, AesMixin)) {
    constructor() {
        super(...arguments);
        this.shopifyProductSyncing = { status: true };
        this.shopifyShippingRateSyncing = { status: true };
        this.shopifyPromoCodeSyncing = { status: true };
        this.isAllowedApp = false;
        this.appGlobalId = '';
        this.UpdatePageImage = {};
        this.toggleLandingDrawer = false;
        this.unverifiedNotificationEmails = [];
        this.unverifiedSupportEmails = [];
        this.unverifiedUserBusinessEmails = [];
        this.existingXenditCustomer = true;
        this.categoryAndDescription = null;
        this.showNotificationVerificationToast = false;
        this.showSupportVerificationToast = false;
        this.showUserBusinessEmailVerificationToast = false;
        this.showMerchantDetailsForm = false;
        this.unverifiedUserBusinessEmailsDismissed = false;
        this.unverifiedNotificationToastMsg = 'Fixed position (top) alert!';
        this.unverifiedSupportToastMsg = 'Fixed position (top) alert!';
        this.unverifiedUserBusinessEmailToastMsg = 'Fixed position (top) alert!';
        this.whiteLabelContent = null;
        this.isShowReminder = false;
        this.hasPendingOrders = false;
        this.shouldRenderModal = false;
        this.openModal = false;
        this.mayaReminderData = '';
        this.advanceOrderModal = false;
        this.advanceOrdersToday = [];
        this.mayaReminder = {
            start_date: '',
            end_date: '',
            remaining_days: '',
            show_reminder: false,
        };
        this.showMayaReminder = false;
        this.showBusinessPromotion = false;
    }
    updateProductSyncStatus(state) {
        this.shopifyProductSyncing.status = state;
    }
    updateShippingRateSyncStatus(state) {
        this.shopifyShippingRateSyncing.status = state;
    }
    updatePromoCodeSyncStatus(state) {
        this.shopifyPromoCodeSyncing.status = state;
    }
    goToAdvanceOrders() {
        this.advanceOrderModal = false;
        this.$router.push({
            name: 'ecommerce-orders-by-status',
            params: { status: 'pending', filter: 'advance' },
        });
    }
    get numberOfAdvancedOrderToday() {
        if (this.advanceOrdersToday.length > 1) {
            return `${this.advanceOrdersToday.length} orders`;
        }
        return `${this.advanceOrdersToday.length} order`;
    }
    onMayaReminderChanged() {
        if (this.triggerMayaReminder) {
            this.$apollo.queries.mayaReminderData.refetch();
        }
    }
    onAppNameChanged() {
        if (this.appUuid) {
            this.runMayaDeactivation();
        }
    }
    closeMayaReminder() {
        this.showMayaReminder = false;
    }
    async runMayaDeactivation() {
        try {
            const data = await this.$apollo.query({
                query: RunMayaDeactivationNotice,
                variables: {
                    appUuid: this.appUUID,
                },
            });
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    async fetchMayaReminder() {
        try {
            const data = await this.$apollo.query({
                query: MayaReminderQuery,
                variables: {
                    appUuid: this.appUUID,
                },
            });
            const { fetchAppByUuid } = data.data;
            this.mayaReminder = fetchAppByUuid?.mayaDeactivationScheduledDates;
            this.showMayaReminder = this.mayaReminder?.show_reminder;
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    async checkIfAppHasPendingOrders() {
        try {
            const data = await this.$apollo.query({
                query: appHasPendingOrders,
                variables: {
                    appUuid: this.appUUID,
                },
            });
            const HasPendingOrders = data.data.app.appHasPendingOrders;
            this.isShowReminder = HasPendingOrders;
        }
        catch (error) {
            this.errorNotification(error.message);
        }
    }
    refetchMayaReminder() {
        this.$apollo.queries.mayaReminderData.refetch();
    }
    onAppUuidChanged() {
        if (!this.appUUID || this.appUUID === '') {
            this.categoryAndDescription = null;
            this.showMerchantDetailsForm = false;
            this.appGlobalId = '';
        }
        else {
            this.$apollo.queries.appGlobalId.refetch();
            this.$apollo.queries.appCategoryDescription.refetch();
        }
    }
    onBundleKeyChanged() {
        this.showNotificationVerificationToast = false;
        this.showSupportVerificationToast = false;
        this.unverifiedNotificationEmails = [];
        this.unverifiedSupportEmails = [];
        this.$store.commit('resetAppState');
    }
    onTokenChanged() {
        this.showUserBusinessEmailVerificationToast = false;
        this.unverifiedUserBusinessEmails = [];
        if (this.token) {
            this.$apollo
                .query({
                query: me,
            })
                .then((meQuery) => {
                const profile = meQuery.data.me;
                const vm = this;
                vm.$store.commit('populateUserUUID', profile.uuid);
                if (profile) {
                    vm.refetchUnverifiedBusinessEmails(profile.uuid);
                }
            });
        }
        else {
            this.$store.commit('populateUserUUID', '');
        }
    }
    onUserChanged() {
        if (this.userUuid) {
            this.$apollo.queries.unverifiedUserBusinessEmails.refetch();
        }
    }
    onRouteChanged() {
        const vm = this;
        const isBillingRoute = Boolean(vm.$route.matched.find((route) => route.path === '/apps/:key/:appUUID/billing'));
        if (isBillingRoute && !vm.existingXenditCustomer) {
            this.openModal = true;
        }
    }
    refetchUnverifiedBusinessEmails(userUuid) {
        if (userUuid) {
            this.$store.commit('populateUserUUID', userUuid);
            this.unverifiedUserBusinessEmailsDismissed = false;
            this.$apollo.queries.unverifiedUserBusinessEmails.refetch();
        }
    }
    onBusinessEmailAlertDismissed() {
        this.showUserBusinessEmailVerificationToast = false;
        this.unverifiedUserBusinessEmails = [];
        this.unverifiedUserBusinessEmailsDismissed = true;
    }
    get toggleDrawer() {
        if (this.openModal) {
            return true;
        }
        return this.$store.state.navigation_drawer.toggleDrawer;
    }
    get appUUID() {
        return this.$store.state.appUUID;
    }
    get baseAppUUID() {
        return this.decrypt(this.$store.state.appUUID);
    }
    get hasTodoSuccessMessage() {
        return this.$store.state.todoSuccessMessage != null;
    }
    /**
     * Store Manager Dashboard Checker
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.21.0}
     */
    get isStoreManager() {
        return this.bundleKey === STORE_MANAGEMENT;
    }
    displayBreadCrumb() {
        if (this.smAndDown) {
            return ((!this.isLogin() &&
                !this.isAppsPath() &&
                !this.isHomePage() &&
                this.showInbox &&
                this.isAdsPath() &&
                !this.isDiy() &&
                this.appUUID) ||
                this.isSalesPartnerPage() ||
                this.isNetworkDistributorPage());
        }
        return ((!this.isLogin() &&
            this.toggleDrawer &&
            !this.showInbox &&
            this.isAdsPath() &&
            this.appUUID &&
            !this.isHomePage() &&
            !this.isAffiliateMerchantDiy()) ||
            this.isSalesPartnerPage() ||
            this.isNetworkDistributorPage());
    }
    noPadding() {
        return (!this.isOverview() && !this.isPerformance() && !this.isProducts() && !this.isCategories());
    }
    getWhiteLabelHeadPageLoad() {
        const favicon = document.getElementById('favicon');
        const title = document.getElementById('title');
        if (this.whiteLabelContent && !CG_BASE_URL.includes(this.getOrigin)) {
            favicon.href = this.whiteLabelContent.whiteLabelFavicon;
            title.text = this.whiteLabelContent.whiteLabelHeader;
        }
        else if (this.whiteLabelContent === null) {
            favicon.href = `${process.env.BASE_URL}chatgenie-favicon.ico`;
        }
    }
    mounted() {
        this.showMayaReminder = false;
        if (this.isAffiliateOverview()) {
            this.$store.commit('navigation_drawer/toggleDrawer', true);
        }
        if (this.isHomePage()) {
            this.initialWhiteLabelContent(this.getOrigin);
        }
    }
    initialWhiteLabelContent(redirectOrigin) {
        const title = document.getElementById('title');
        if (!CG_BASE_URL.includes(redirectOrigin)) {
            title.text = '';
        }
        else {
            title.text = 'Chatgenie - Online Store Inside Messenger';
        }
    }
    get whiteLabelQueryLoading() {
        return this.$apollo.queries.whiteLabelContent.loading;
    }
    get isInquiry() {
        const { params } = this.$route;
        return params.key === Bundle.Inquiry;
    }
    get isAffiliatePage() {
        const { params } = this.$route;
        return params.key === Bundle.Affiliate;
    }
    get isInsuranceBundle() {
        return this.$route.params.key === Bundle.Insurance;
    }
    showBillingWidget(display) {
        return (!this.isDiy() &&
            !this.isSalesPartnerPage() &&
            !this.isNetworkDistributorPage() &&
            !this.isAffiliatePage &&
            display);
    }
    get isAffiliate() {
        const { params } = this.$route;
        return params.userType === UserType.Affiliate;
    }
    async closeMdrDialog() {
        const vm = this;
        await vm.$refs.app.refetch();
        vm.successNotification('2.5% MDR is already applied to all product prices');
    }
    get diy() {
        return this.isDiy();
    }
    get mdrExcludedBundle() {
        return (this.bundleKey === 'insurance-bundle' ||
            this.bundleKey === 'inquiry-bundle' ||
            this.bundleKey === 'affiliate-bundle' ||
            this.bundleKey === '');
    }
    get isShopifyBundle() {
        return this.bundleKey === 'shopify-bundle';
    }
    get isAffiliateBundle() {
        return this.bundleKey === 'affiliate-bundle';
    }
    get showCreditWidget() {
        return (!this.isDiy() &&
            !this.isInquiry &&
            !this.isSalesPartnerPage() &&
            !this.isNetworkDistributorPage() &&
            !this.isAffiliatePage);
    }
    async onResendEmail(supportEmail = false) {
        return this.$apollo
            .mutate({
            mutation: AppResendVerificationEmail,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    supportEmail,
                },
            },
        })
            .then((result) => {
            const data = result.data.appResendVerificationEmail;
            if (data) {
                this.successNotification(`Verification email sent to ${this.unverifiedNotificationEmails.join(', ')}`);
                if (supportEmail) {
                    this.showSupportVerificationToast = false;
                }
                else {
                    this.showNotificationVerificationToast = false;
                }
            }
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    async onUserResendEmail() {
        return this.$apollo
            .mutate({
            mutation: UserResendVerificationEmail,
            variables: {
                input: {
                    userUuid: this.userUuid,
                },
            },
        })
            .then((result) => {
            const data = result.data.userResendVerificationEmail;
            if (data) {
                this.successNotification(`Verification email sent to ${this.unverifiedUserBusinessEmails.join(', ')}`);
                this.showUserBusinessEmailVerificationToast = false;
            }
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    isTodayMonday() {
        const today = new Date();
        // Check if today is Monday (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        return today.getDay() === 1;
    }
    async closeBusinessPromotion() {
        const child = this.$refs.businessPromotionChild;
        if (child.doNotShowPopup) {
            return this.$apollo
                .mutate({
                mutation: updateBusinessPromotionReminder,
                variables: {
                    input: {
                        appUuid: this.appUUID,
                        businessPromotionReminder: child.doNotShowPopup,
                    },
                },
            })
                .then((result) => {
                const data = result.data.updateBusinessPromotionReminder;
                if (data) {
                    this.showBusinessPromotion = false;
                    this.$apollo.queries.appGlobalId.refetch();
                }
            })
                .catch((e) => {
                console.error(`Failed to update reminder: ${e.message}`);
            });
        }
        this.showBusinessPromotion = false;
    }
};
__decorate([
    Getter('fromAppsDashboard', { namespace: 'session' })
], App.prototype, "fromAppsDashboard", void 0);
__decorate([
    Getter('showInbox', { namespace: NAV_DRAWER })
], App.prototype, "showInbox", void 0);
__decorate([
    Getter('mayaReminder', { namespace: NAV_DRAWER })
], App.prototype, "triggerMayaReminder", void 0);
__decorate([
    Getter('token', { namespace: 'session' })
], App.prototype, "token", void 0);
__decorate([
    Getter('appUuid')
], App.prototype, "appUuid", void 0);
__decorate([
    Getter('userUuid')
], App.prototype, "userUuid", void 0);
__decorate([
    Provide()
], App.prototype, "shopifyProductSyncing", void 0);
__decorate([
    Provide()
], App.prototype, "shopifyShippingRateSyncing", void 0);
__decorate([
    Provide()
], App.prototype, "shopifyPromoCodeSyncing", void 0);
__decorate([
    Provide()
], App.prototype, "updateProductSyncStatus", null);
__decorate([
    Provide()
], App.prototype, "updateShippingRateSyncStatus", null);
__decorate([
    Provide()
], App.prototype, "updatePromoCodeSyncStatus", null);
__decorate([
    Watch('triggerMayaReminder')
], App.prototype, "onMayaReminderChanged", null);
__decorate([
    Watch('appUuid')
], App.prototype, "onAppNameChanged", null);
__decorate([
    Watch('appUUID')
], App.prototype, "onAppUuidChanged", null);
__decorate([
    Watch('bundleKey')
], App.prototype, "onBundleKeyChanged", null);
__decorate([
    Watch('token')
], App.prototype, "onTokenChanged", null);
__decorate([
    Watch('userUuid')
], App.prototype, "onUserChanged", null);
__decorate([
    Watch('$route')
], App.prototype, "onRouteChanged", null);
__decorate([
    Watch('whiteLabelContent', { immediate: true })
], App.prototype, "getWhiteLabelHeadPageLoad", null);
App = __decorate([
    Component({
        components: {
            AppBasicDetails,
            AccumulatedConvenienceFee,
            BillingDeactivationNoticeDialog,
            EnterprisePlanFee,
            TopNav,
            TopSubNav,
            SideNav,
            TheAlert,
            TheBreadcrumb,
            PageTransition,
            NotificationList,
            TheLaunchDialog,
            TheSuccessDialog,
            TheDiyTerms,
            MobileUserSettings,
            PendingOrderNoticeDialog,
            GracePeriodLastDayNoticeDialog,
            CreditWidget,
            LandingDrawer,
            SessionExpiredDialog,
            TuckingInMdrDialog,
            SupportDetailsDialog,
            ActionButton,
            MerchantCategoryDescription,
            Modal,
            ToDoSuccess,
            PendingOrderReminder,
            ShopifyProgressBar,
            MayaDeactivationReminder,
            BusinessMessagingPromotion,
        },
        computed: {
            isDay6OfTheMonth() {
                const today = new Date();
                const dayOfMonth = today.getDate();
                return dayOfMonth === 7;
            },
            isFirstDayOfMonth() {
                const today = new Date();
                return today.getDate() === 1;
            },
            checkDateToday() {
                if (this.isDay6OfTheMonth || this.isFirstDayOfMonth) {
                    this.checkIfAppHasPendingOrders();
                    return this.isShowReminder;
                }
                return false;
            },
            checkIfShowMayaReminder() {
                this.fetchMayaReminder();
                return this.mayaReminder?.show_reminder;
            },
            isAlertOpen() {
                return this.$store.state.toggleAlert === true;
            },
        },
        apollo: {
            UpdatePageImage: {
                query: UpdatePageImage,
                skip() {
                    return !this.appUUID;
                },
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    return data.updatePageImage;
                },
            },
            appGlobalId: {
                query: AppGlobalId,
                skip() {
                    return !this.appUUID;
                },
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    this.$store.commit('setAppGlobalId', data?.fetchAppByUuid.baseGlobalId);
                    this.isAllowedApp = data.fetchAppByUuid.allowedApp;
                    this.$store.commit('setIsInboxManagerAllowedApp', this.isAllowedApp);
                    this.$store.commit('setSentimentAnalysisEnabled', data.fetchAppByUuid.sentimentAnalysisEnabled);
                    return data.fetchAppByUuid.baseGlobalId;
                },
            },
            mayaReminderData: {
                query: MayaReminderQuery,
                skip() {
                    return !this.appUUID;
                },
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    this.mayaReminder = data?.fetchAppByUuid?.mayaDeactivationScheduledDates;
                    this.$store.commit('setMayaDeactivationEndDate', this.mayaReminder?.end_date);
                    const { showMayaReminder } = this.$store.state;
                    if (this.mayaReminder?.show_reminder &&
                        showMayaReminder?.appUuid !== this.appUUID) {
                        this.showMayaReminder = true;
                        const reminder = {
                            appUuid: this.appUUID,
                        };
                        this.$store.commit('setShowMayaReminder', reminder);
                    }
                    return data.fetchAppByUuid.baseGlobalId;
                },
            },
            unverifiedNotificationEmails: {
                query: UnverifiedNotificationEmails,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    const emails = data.fetchUnverifiedNotificationEmails;
                    if (emails.length > 0) {
                        this.unverifiedNotificationToastMsg = `Complete your account setup: Verify email (${emails.join(',')}) for full dashboard access.`;
                        this.showNotificationVerificationToast = true;
                    }
                    return emails;
                },
                skip() {
                    return !this.appUUID;
                },
            },
            unverifiedSupportEmails: {
                query: UnverifiedSupportEmails,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    const emails = data.fetchUnverifiedSupportEmails;
                    if (emails.length > 0) {
                        this.unverifiedSupportToastMsg = `Complete support email setup: Verify email (${emails.join(',')}) to receive customer inquiries.`;
                        this.showSupportVerificationToast = true;
                    }
                    return emails;
                },
                skip() {
                    return !this.appUUID;
                },
            },
            unverifiedUserBusinessEmails: {
                query: UnverifiedBusinessEmails,
                variables() {
                    return {
                        userUuid: this.userUuid,
                    };
                },
                update(data) {
                    const emails = data.unverifiedUserBusinessEmail;
                    if (emails.length > 0 && !this.unverifiedUserBusinessEmailsDismissed) {
                        this.unverifiedUserBusinessEmailToastMsg = `Complete your account setup: Verify business email (${emails.join(',')}) for full dashboard access.`;
                        this.showUserBusinessEmailVerificationToast = true;
                    }
                    else {
                        this.showUserBusinessEmailVerificationToast = false;
                        this.unverifiedUserBusinessEmails = [];
                    }
                },
                skip() {
                    return !this.userUuid;
                },
            },
            appCategoryDescription: {
                query: FetchCategoryAndDesc,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update({ app }) {
                    this.categoryAndDescription = app;
                    const { categoryTree, businessDescription } = app;
                    this.showMerchantDetailsForm = !(categoryTree && businessDescription);
                },
                skip() {
                    return !this.appUUID;
                },
            },
            existingCustomer: {
                query: CustomerDetails,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    if (data.fetchCustomerDetails) {
                        this.existingXenditCustomer = true;
                    }
                    else {
                        this.existingXenditCustomer = false;
                    }
                },
                skip() {
                    return !this.appUUID;
                },
            },
            fetchSubscriptionInvitation: {
                query: fetchSubscriptionInvitation,
                skip() {
                    return !this.appUUID;
                },
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                async result({ data }) {
                    const subscriptionInvitation = data?.fetchSubscriptionInvitation;
                    const businessPromotion = JSON.parse(localStorage.getItem('businessPromotion') || '{}');
                    const { data: appStatusData } = await this.$apollo.query({
                        query: AppStatus,
                        variables: { appUuid: this.appUUID },
                    });
                    switch (this.bundleKey) {
                        case 'shopify-bundle':
                            if (!this.isShopifyOverview())
                                return;
                            break;
                        case 'ecommerce-b2c-bundle':
                            if (!this.isOverview())
                                return;
                            break;
                        case 'insurance-bundle':
                            return;
                        default:
                            return;
                    }
                    if (subscriptionInvitation || appStatusData?.app?.status !== 'Active') {
                        return;
                    }
                    const shouldShowPromotion = this.isTodayMonday() && businessPromotion?.appUuid !== this.appUUID;
                    if (shouldShowPromotion && !appStatusData.app.businessPromotionReminder) {
                        this.showBusinessPromotion = true;
                        const reminder = {
                            appUuid: this.appUUID,
                        };
                        localStorage.setItem('businessPromotion', JSON.stringify(reminder));
                    }
                },
            },
            advanceOrdersToday: {
                query: AdvanceOrdersToday,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    const ordersForToday = data.fetchAdvanceOrdersForToday;
                    if (ordersForToday && ordersForToday.length > 0) {
                        this.advanceOrderModal = true;
                    }
                    return ordersForToday;
                },
                skip() {
                    return !this.appUUID;
                },
            },
        },
    })
], App);
export default App;
